import { Card, CardBody, Col } from 'reactstrap';
import FormCard from './FormCard';

import CommonCardHeader from '../../../../../../coreComponents/CommonCardHeader';
import { BaseInput } from '../../../../../../types/Forms';
import { coursesList } from '../../../../../../data/courses/coursesList';

interface ValidationFormProps<T> {
  inputs: BaseInput<any>[];
  formTitle?: string;
  formSubTitle?: string;
  submitHandler: (data: T) => void;
  defaultValues: Partial<T>;
  mode: 'create' | 'edit';
  subject: 'user' | 'course' | 'feedback';
  coursesList?: {
    value: string;
    label: string;
  }[];
}

const ValidationForm = <T extends object>({
  inputs,
  formTitle,
  formSubTitle,
  submitHandler,
  defaultValues,
  mode,
  subject,
  coursesList,
}: ValidationFormProps<T>) => {
  return (
    <Col xl="12">
      <Card>
        {formTitle && <CommonCardHeader title={formTitle} span={[{ text: formSubTitle }]} />}
        <CardBody>
          <FormCard<T>
            inputs={inputs}
            submitHandler={submitHandler}
            defaultValues={defaultValues}
            mode={mode}
            subject={subject}
            coursesList={coursesList}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default ValidationForm;
